import { Logo } from '@/components/brand/Logo';

/**
 * Full-screen loading mark shown while platform configuration resolves —
 * BUILD-PLAN §3 ("loading/splash mark"), §41 loading state.
 *
 * A branded moment rather than a spinner: this is the first thing a visitor
 * sees, so it carries the identity instead of undermining it.
 */
export function BrandSplash() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-background"
      role="status"
      aria-live="polite"
    >
      <div className="animate-pulse motion-reduce:animate-none">
        <Logo size="lg" decorative />
      </div>

      <span className="sr-only">Loading Glanz Luxe</span>
    </div>
  );
}
